import React, { useEffect, useRef } from 'react';
import { createChart } from 'lightweight-charts';

const TradingViewChart = ({ coinSymbol = 'BTC', height = 240 }) => {
  const chartContainerRef = useRef();

  useEffect(() => {
    if (!chartContainerRef.current) return;

    const chart = createChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: height,
      layout: {
        background: { type: 'solid', color: '#f8f9fa' },
        textColor: '#6c757d',
        fontSize: 11,
      },
      grid: {
        vertLines: { color: '#e9ecef' },
        horzLines: { color: '#e9ecef' },
      },
      rightPriceScale: {
        borderColor: '#dee2e6',
        scaleMargins: {
          top: 0.1,
          bottom: 0.1,
        },
      },
      timeScale: {
        borderColor: '#dee2e6',
        timeVisible: true,
        secondsVisible: false,
      },
      crosshair: {
        vertLine: {
          color: '#9e9e9e',
          width: 0.5,
          style: 1,
          labelBackgroundColor: '#6c757d',
        },
        horzLine: {
          color: '#9e9e9e',
          width: 0.5,
          style: 1,
          labelBackgroundColor: '#6c757d',
        },
      },
    });

    // Generate data for both profit and loss
    const generateData = (isProfit) => {
      const data = [];
      let price = 100;
      const now = Math.floor(Date.now() / 1000);

      for (let i = 40; i >= 0; i--) {
        const time = now - i * 180;
        const volatility = Math.random() * 0.8;
        const trend = isProfit ? 0.52 : 0.48;
        price = price + (Math.random() - trend) * volatility;

        data.push({
          time,
          value: parseFloat(price.toFixed(2)),
        });
      }
      return data;
    };

    // Profit line (Green)
    const profitSeries = chart.addAreaSeries({
      lineColor: '#10b981',
      topColor: 'rgba(16, 185, 129, 0.2)',
      bottomColor: 'rgba(16, 185, 129, 0.0)',
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: true,
    });

    // Loss line (Red)
    const lossSeries = chart.addAreaSeries({
      lineColor: '#ef4444',
      topColor: 'rgba(239, 68, 68, 0.2)',
      bottomColor: 'rgba(239, 68, 68, 0.0)',
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: true,
    });

    profitSeries.setData(generateData(true));
    lossSeries.setData(generateData(false));

    const handleResize = () => {
      if (chartContainerRef.current) {
        chart.applyOptions({ width: chartContainerRef.current.clientWidth });
      }
    };

    window.addEventListener('resize', handleResize);
    chart.timeScale().fitContent();

    return () => {
      window.removeEventListener('resize', handleResize);
      chart.remove();
    };
  }, [coinSymbol, height]);

  return (
    <div>
      <div className='d-flex justify-content-center gap-3 mb-2'>
        <small className='text-success'>● Profit</small>
        <small className='text-danger'>● Loss</small>
      </div>
      <div
        ref={chartContainerRef}
        style={{
          width: '100%',
          height: `${height}px`,
          borderRadius: '6px',
          overflow: 'hidden',
          border: '1px solid #e9ecef',
        }}
      />
    </div>
  );
};

export default TradingViewChart;
